<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          class="mr-2"
          :href="`whatsapp://send?phone=+55${customer.phone_nomask}&text=${encodeURIComponent(get_options.birthday_text)}`"
          target="_blank"
          :disabled="!(customer.phone_nomask > 0)"
        >
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.whatsapp }}</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          class="mr-2"
          :href="`tel:${customer.phone_nomask}`"
          target="_blank"
          :disabled="!(customer.phone_nomask > 0)"
        >
          <v-icon>mdi-phone-in-talk</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.call }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    customer: Object
  }
}
</script>

